import { render, staticRenderFns } from "./properties-block-divider.vue?vue&type=template&id=94b18bec&scoped=true"
import script from "./properties-block-divider.vue?vue&type=script&lang=js"
export * from "./properties-block-divider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b18bec",
  null
  
)

export default component.exports